import { DayPicker, getDefaultClassNames } from "react-day-picker";
import BoxIcon from "../../../assets/boxIcon.png";
import CalendarIcon from "../../../assets/calendarioIcon.png";
import ListIcon from "../../../assets/listaIcon.png";
import "react-day-picker/dist/style.css";

import { ptBR } from "react-day-picker/locale";
import { useEffect, useState } from "react";
import api from "../../../services/api";

const Calendario = () => {
  const [eventos, setEventos] = useState([]);
  const [selected, setSelected] = useState();
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const month = currentMonth.getMonth() + 1;
        const year = currentMonth.getFullYear();
        const response = await api.get(`/calendar/${month}?year=${year}`);
        setEventos(response.data);
      } catch (error) {
        console.error("Erro ao obter eventos do calendário: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchEventos();
  }, [currentMonth]);

  const customLocale = {
    ...ptBR,
    localize: {
      ...ptBR.localize,
      day: (day) => ["D", "S", "T", "Q", "Q", "S", "S"][day],
    },
  };

  const defaultClassNames = getDefaultClassNames();
  const today = new Date();

  const modifiers = {
    today: today,
    reminder: eventos.map((item) => new Date(item.createdAt)),
  };

  return (
    <>
      <div className="flex p-2 rounded-full w-[200px] bg-lightGray justify-around">
        <img src={BoxIcon} alt="box Icon" className="w-[24px] h-[24px]" />
        <span className="font-bold uppercase text-boldGray opacity-90 ml-4">
          Recebimento
        </span>
      </div>
      <div className="rounded-xl bg-extraLightGray flex p-6 mt-6 text-boldGray opacity-90">
        <div className="xl:flex w-full ">
          <div className="w-full lg:w-[80%] mx-auto  xl:w-1/2 lg:pr-4 h-screen">
            <div className=" flex items-center md:flex md:justify-center">
              <img
                src={CalendarIcon}
                alt="ícone calendário"
                className="md:w-[45px] lg:w-[50px] xl:w-[55px] ml-2"
              />
              <span className="text-xl font-bold ml-6">Calendário</span>
            </div>
            <DayPicker
              mode="single"
              classNames={{
                ...defaultClassNames,
                root: "flex flex-col md:mt-6 xl:mt-14 md:flex md:items-center md:justify-center text-2xl sm:text-3xl lg:text-4xl",
                month:
                  "flex flex-col w-full h-auto md:w-[520px] md:h-[424px] xl:w-[500px] 2xl:w-[600px] ",
                caption_label:
                  "text-[#2F2E41] text-sm sm:text-base font-semibold",
                chevron: "fill-[#2F2E41]",
                month_grid:
                  "bg-white flex flex-col justify-center rounded-lg px-2 sm:px-4 pt-2 sm:pt-4 mt-1 w-full lg:w-[520px] xl:w-[500px] 2xl:w-[600px]",
                weekdays:
                  "grid grid-cols-7 gap-1 sm:gap-2 text-center text-xs sm:text-sm md:text-base text-[#2F2E41] font-bold",
                week: "grid grid-cols-7 gap-x-1 sm:gap-x-3 md:gap-x-4 lg:gap-x-5 my-1 sm:my-2 md:my-3 text-center items-center justify-center",
                day: "flex items-center justify-center text-center h-[36px]  md:h-[56px]  w-[36px]  md:w-[56px] ",
                day_button:
                  "text-[#2F2E41] text-xs sm:text-sm md:text-base rounded-full px-2 py-1 hover:bg-[#D0D0D0]",
                selected:
                  "bg-[#FF9533] text-white rounded-full  md:h-[56px] md:w-[56px] flex items-center justify-center",
              }}
              locale={customLocale}
              selected={selected}
              onSelect={setSelected}
              modifiers={modifiers}
              modifiersClassNames={{
                today: "bg-orange-500 text-white rounded-full",
                reminder: "bg-gray-500 text-white rounded-full",
              }}
              onMonthChange={setCurrentMonth}
            />
          </div>

          <div className="w-full lg:w-[80%] xl:w-1/2 mx-auto xl:ml-4 md:mt-6 xl:mt-0">
            <div className="flex items-center md:flex md:justify-center">
              <img
                src={ListIcon}
                alt="ícone lista"
                className="md:w-[45px] lg:w-[50px] xl:w-[55px] ml-2"
              />
              <span className="text-xl font-bold ml-6">Lista de Eventos</span>
            </div>

            <div className="max-h-[440px] overflow-y-auto mt-10 custom-scrollbar">
              {isLoading && <p>Carregando eventos...</p>}
              {eventos &&
                eventos.map((item, index) => (
                  <div
                    key={index}
                    className="bg-lightGray flex py-5 mt-2 rounded-md px-8 mr-6 justify-between text-boldGray opacity-90"
                  >
                    <div className="flex">
                      <span className="font-bold text-primary">
                        {new Date(item.createdAt).toLocaleDateString("pt-BR", {
                          day: "2-digit",
                          month: "short",
                        })}
                      </span>
                      <p className="ml-6">{item.message}</p>
                    </div>
                    <span className="font-bold ">{item.code}</span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Calendario;
